import React from 'react'
import { HandThumbsUpFill, HandThumbsDownFill, Circle } from 'react-bootstrap-icons'
import HandThumbsSidewaysFill from './HandThumbsSidewaysFill'

const STATUS_BY_INDEX = ['pending', 'selected', 'rejected', 'backuped']

const selectionStatusConfig = {
  selected: { Icon: HandThumbsUpFill, color: 'text-green-600 dark:text-green-400', title: 'Yes, fits the brand' },
  rejected: { Icon: HandThumbsDownFill, color: 'text-red-600 dark:text-red-400', title: 'Do not contact' },
  backuped: { Icon: HandThumbsSidewaysFill, color: 'text-yellow-600 dark:text-yellow-400', title: 'Backup / alternative' },
  pending: { Icon: Circle, color: 'text-rb-lighter-grey dark:text-rb-dark-mode-text-grey', title: 'Pending' }
}

export default function SelectionStatusIcon({ selectionStatus, size = 20 }) {
  const key = typeof selectionStatus === 'number' ? STATUS_BY_INDEX[selectionStatus] : selectionStatus
  const config = selectionStatusConfig[key] || selectionStatusConfig.pending
  const { Icon, color, title } = config
  return (
    <span className={color} title={title} aria-label={title}>
      <Icon size={size} />
    </span>
  )
}
